import React from 'react';
import { resolvePath } from 'react-router';

import Layout from 'shared/components/Layout/Layout';
import useUser from 'hooks/useUser';
import usePageName from 'hooks/usePageName';
import { useFeatureFlags } from 'hooks/useFeatureFlags';
import { ContractType, FlagKey } from 'api/types';
import OverviewIcon from 'shared/components/icons/OverviewIcon';
import SystemIcon from 'shared/components/icons/SystemIcon';
import BillingIcon from 'shared/components/icons/BillingIcon';
import SupportIcon from 'shared/components/icons/SupportIcon';
import VPPIcon from 'shared/components/icons/VPPIcon';
import pages from 'pages';
import { getDashboardRedirectPath } from 'modules/auth/Auth.utils';
import { useTranslation } from 'react-i18next';

export function DashboardLayout() {
  const { userResult, selectedAgreement } = useUser();
  const { currentPage } = usePageName();
  const { t } = useTranslation('translation', { keyPrefix: 'overview' });

  const {
    flags: { [FlagKey.vpp2025_prelaunch_web]: vpp, [FlagKey.onboardingRefresh]: onboardingRefresh },
  } = useFeatureFlags();

  const { hasDashboardAccess } = getDashboardRedirectPath(
    userResult?.user || undefined,
    selectedAgreement,
    onboardingRefresh,
  );

  const vppEnabled =
    hasDashboardAccess && vpp && selectedAgreement?.contract_type === ContractType.PPA;

  const overviewIcon = () => <OverviewIcon filled={currentPage === 'OVERVIEW'} />;
  const systemIcon = () => <SystemIcon filled={currentPage === 'SYSTEM'} />;
  const billingIcon = () => <BillingIcon filled={currentPage === 'BILLING'} />;
  const vppIcon = () => <VPPIcon filled={currentPage === 'VPP'} />;
  const supportIcon = () => <SupportIcon filled={currentPage === 'SUPPORT'} />;

  const overviewMenuOptions = [
    {
      label: t('overview'),
      link: resolvePath(pages.OVERVIEW, `/${pages.DASHBOARD}`),
      icon: overviewIcon,
    },
    ...(hasDashboardAccess
      ? [
          {
            label: t('system'),
            link: resolvePath(pages.SYSTEM, `/${pages.DASHBOARD}`),
            icon: systemIcon,
          },
          {
            label: t('billing'),
            link: resolvePath(pages.BILLING, `/${pages.DASHBOARD}`),
            icon: billingIcon,
          },
        ]
      : []),
    ...(vppEnabled
      ? [
          {
            label: 'VPP',
            link: resolvePath(pages.VPP, `/${pages.DASHBOARD}`),
            icon: vppIcon,
          },
        ]
      : []),
    {
      label: t('support'),
      link: !hasDashboardAccess
        ? resolvePath(`/${pages.SUPPORT}`)
        : resolvePath(pages.SUPPORT, `/${pages.DASHBOARD}`),
      icon: supportIcon,
    },
  ];

  return <Layout hasNav menuOptions={overviewMenuOptions} />;
}

export default DashboardLayout;
